export default __webpack_public_path__ + "0df3f840c14789f553cb754262e17f36.png";